import { render, staticRenderFns } from "./Preorder.vue?vue&type=template&id=6e670842&"
import script from "./Preorder.vue?vue&type=script&lang=js&"
export * from "./Preorder.vue?vue&type=script&lang=js&"
import style0 from "./Preorder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports